import { Check, X } from "lucide-react";
import { ROLE_LABELS } from "@/lib/roles";

const STAFF_ROLES = ["super_admin", "director", "teacher", "accountant", "receptionist", "attendance_officer", "inventory_officer"];
const toggleBusinessRole = (selected, role) => selected.includes(role) ? selected.filter((item) => item !== role) : [...selected, role];

const MultiRoleSelect = ({ value = [], onChange, disabled = false, testId = "multi-role" }) => {
  const selected = Array.isArray(value) ? value : (value ? [value] : []);

  const toggle = (role) => {
    if (disabled) return;
    onChange(toggleBusinessRole(selected, role));
  };

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        {STAFF_ROLES.map((r) => {
          const isOn = selected.includes(r);
          return (
            <button
              key={r}
              type="button"
              disabled={disabled}
              onClick={() => toggle(r)}
              className={
                "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border transition-all " +
                (isOn
                  ? "bg-[#1B2C5A] text-white border-[#1B2C5A] shadow-sm"
                  : "bg-white text-[#475569] border-[#E2E8F0] hover:border-[#1B2C5A] hover:text-[#1B2C5A]")
              }
              data-testid={`${testId}-${r}`}
            >
              {isOn ? <Check className="w-3 h-3" /> : <span className="w-3 h-3" />}
              {ROLE_LABELS[r] || r}
            </button>
          );
        })}
      </div>
      <div className="text-xs text-[#475569]">{selected.length ? `${selected.length} business role${selected.length > 1 ? "s" : ""} selected` : "Profile only — permissions come from positions or explicit access."}</div>
    </div>
  );
};

export default MultiRoleSelect;
export { STAFF_ROLES, toggleBusinessRole };
